import { render, staticRenderFns } from "./dialogEditSubcategory.vue?vue&type=template&id=44820456&lang=html"
import script from "./dialogEditSubcategory.vue?vue&type=script&lang=js"
export * from "./dialogEditSubcategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports